module.exports = __webpack_public_path__ + "static/media/feature-invite1.e1ec0d82.png";